import { Accordion, Checkbox } from "@swot/base-components";
import type { CmtsGridColumn } from "./CmtsSmartDataGridTypes.js";

export function CmtsSmartDataGridColumnManager<TRecord extends Record<string, unknown>>(props: {
  columns: readonly CmtsGridColumn<TRecord>[];
  visibleColumnIds: readonly string[];
  onToggle: (columnId: string) => void;
}) {
  return (
    <div className="cmts-smart-grid-column-manager">
      <Accordion title="Columns">
        <div>
          {props.columns.map((column) => (
            <Checkbox key={column.id} label={column.header} checked={props.visibleColumnIds.includes(column.id)} onChange={() => props.onToggle(column.id)} />
          ))}
        </div>
      </Accordion>
    </div>
  );
}
